
import { Component, Prop, Vue } from 'vue-property-decorator';

import BuyBox from '@/components/buybox/BuyBox.vue';
import BaseModal from '@/components/modals/BaseModal.vue';

import { WatchlistTitleGraphqlFragment } from '@/components/watchlist/graphql/fragments/WatchlistTitle.fragment';

import { OfferPresentationType } from '@/interfaces/titles';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import { TvShowTrackingTitleFragment } from '@/components/watchlist/graphql/fragments/TVShowTrackingTitle.fragment';

@Component({
	name: 'WatchNowModal',
	components: { BuyBox, BaseModal },
})
export default class WatchNowModal extends Vue {
	watchlistEntryV2: { createdAt: string } | null;
	// When a modal is created its lose props references and props are not updating, so we use the flag to be sure that
	// prop title is align with GraphQL cache
	isTitleAlignedWithCache: boolean = true;

	@Prop() title: WatchlistTitleGraphqlFragment['node'] | TvShowTrackingTitleFragment['node'];
	@Prop({ default: false }) isNextEpisodeButton: boolean;
	@Prop() defaultPresentationType: OfferPresentationType;
	@Prop({ default: null }) sponsoredAd: SponsoredAdFragment;

	get titleToDisplay() {
		if (this.isNextEpisodeButton && 'watchNextEpisode' in this.title && this.title.watchNextEpisode) {
			return this.title.watchNextEpisode;
		}

		return this.title;
	}

	get seasonNumber() {
		if (this.titleToDisplay.__typename === 'Episode') {
			return this.titleToDisplay?.content.seasonNumber;
		}

		return null;
	}

	get episodeNumber() {
		if (this.titleToDisplay.__typename === 'Episode') {
			return this.titleToDisplay?.content.episodeNumber;
		}

		return null;
	}

	get headerTitle() {
		if (this.titleToDisplay.__typename === 'Episode') {
			return `${this.titleToDisplay?.content.title} - S${this.seasonNumber}E${this.episodeNumber}`;
		}

		return this.titleToDisplay.content.title;
	}

	get showDetails() {
		if (this.titleToDisplay.__typename === 'Episode') {
			return {
				id: this.title.id,
				objectId: this.title.objectId,
				objectType: this.title.objectType,
				title: this.title.content.title,
			};
		}

		return null;
	}

	get updatedTitle() {
		const updatedTitle = {
			...this.title,
			watchlistEntryV2: this.isTitleAlignedWithCache ? this.title.watchlistEntryV2 : this.watchlistEntryV2,
		};

		this.isTitleAlignedWithCache = true;

		return updatedTitle;
	}

	onWatchlistToggle(createdAt: string | null) {
		this.isTitleAlignedWithCache = false;
		this.watchlistEntryV2 = createdAt
			? {
					createdAt,
			  }
			: null;
	}
}
